import { render, staticRenderFns } from "./cModalDelete.vue?vue&type=template&id=323bbdf8&scoped=true"
import script from "./cModalDelete.vue?vue&type=script&lang=js"
export * from "./cModalDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323bbdf8",
  null
  
)

export default component.exports